<label for="Phone" class=" internship_label text-secondary">Phone*</label>
  <input #telInput class="form-control my-4"
    type="tel"
    style="height: 60px;"
    class="{{isInvalid ? '':'text-danger'}}"
    [(ngModel)]="phoneNumber"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (keypress)="onInputKeyPress($event)"
    (ngModelChange)="onPhoneNumberChange()"
    id="phoneInput" name="Phone"
  />
  <!-- <div class="container-fluid p-0 form-floating my-4">
    <div class="row align-items-center">
      <div class="col-md-auto col-12">
        <label for="phoneInput" class="internship_label text-secondary">Phone*</label>
      </div>
      <div class="col-md col-12 p-0">
        <input #telInput class="form-control"
          type="tel"
          style="height: 60px;"
          [class.text-danger]="isInvalid"
          [(ngModel)]="phoneNumber"
          (focus)="onFocus()"
          (blur)="onBlur()"
          (keypress)="onInputKeyPress($event)"
          (ngModelChange)="onPhoneNumberChange()"
          id="phoneInput" name="Phone"
        />
      </div>
    </div>
  </div> -->
 

